import React from 'react';
import {DmsTab} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col,message} from 'antd';
import {showSpin,hideSpin} from 'Utils';
import {brandDetail, saveOrUpdate} from '../../service/productBrand';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;
import {nameValidator,checkCode} from '../../utils/regexp.js';


class ProBrandadd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['新建品牌'],
			detail: {}
		}
		this.checkSortOrder=this.checkSortOrder.bind(this);
	}
	
	componentDidMount() {
		//console.log(this.props.location.query.index);
		if (this.props.location.query.brandId) {
			this.setState({
				opts: ['编辑品牌']
			})
			//根据传过来的index，获取特定的值，并赋值给detail
			var detailObj = {};
			detailObj.id = parseInt(this.props.location.query.brandId, 0);
			brandDetail(detailObj).then(result => {
				if(result.status){
					this.setState({
						detail: result.data
					})
				}else{
					message.error(result.message);
				}
			})
		}
	}
	
	cancelHandle() {
		hashHistory.goBack();
	}
	
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			if (data.active === '1') {
				data.active = 1;
			} else {
				data.active = 0;
			}
			
			if (this.props.location.query.brandId) {
				data.id = this.state.detail.id;
			}

      showSpin();
			saveOrUpdate(data).then(result=>{
				hideSpin();
				if(result.status){
					message.success(result.message);
					hashHistory.goBack();
				}else{
					message.error(result.message);
				}
			})
		})
		
	}
	
	//排序正则
	checkSortOrder(rule, value, callback) {
		const vaReg = /^\d{1,}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('排序只可输入整数');
			}
			callback();
		}
		callback();
	}
	
	render() {
		const {opts, detail} = this.state;
		const {getFieldDecorator} = this.props.form;
		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>
			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
				<Form layout="horizontal">
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="品牌名称" hasFeedback>
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : '',
									rules: [
										{
											required: true,
											message: '请输入品牌名称'
										},
										{
											validator: nameValidator
										}
									],
								})(<Input placeholder="请输入品牌名称"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="品牌编码" hasFeedback>
								{getFieldDecorator('code', {
									initialValue: (detail !== null && detail.code) ? detail.code : '',
									rules: [
										{
											required: true,
											message: '请输入品牌编码'
										},
										{
											validator: checkCode
										}
									],
								})(<Input placeholder="请输入品牌编码"/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row>
						<FormItem label="描述">
							{getFieldDecorator('description', {
								initialValue: (detail !== null && detail.description) ? detail.description : ''
							})(<TextArea rows={4}/>)}
						</FormItem>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="有效性">
								{getFieldDecorator('active', {
									initialValue: (detail !== null && detail.active === 0) ? '0' : "1",
									rules: [
										{
											required: true,
											message: '请选择是否有效'
										},
									]
								})(<Select>
									<Option value='1'>有效</Option>
									<Option value='0'>无效</Option>
								</Select>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="排序">
								{getFieldDecorator('sortOrder', {
									initialValue: (detail !== null && detail.sortOrder != null) ? detail.sortOrder : '',
									rules: [
										{
											validator: this.checkSortOrder
										}
									]
								})(<Input />)}
							</FormItem>
						</Col>
					</Row>
				
				</Form>
			</div>
		</div>
	}
}
export default Form.create()(ProBrandadd)


// WEBPACK FOOTER //
// ./src/routes/productBrand/add.js